import http from "./index";

const getAll = () => {
  return http.get("./programs");
};

const getOne = (id) => {
  return http.get(`./programs/${id}`);
};

const create = (data_send) => {
  return http.post("./programs", data_send);
};

const update = (id, data_send) => {
  return http.put(`./programs/${id}`, data_send);
};

const remove = (id) => {
  return http.delete(`./programs/${id}`);
};

const programService = {
  getAll,
  getOne,
  create,
  update,
  remove,
};

export default programService;
